import { loop, Cmd } from 'redux-loop';
import {assocPath} from 'ramda';
import {pipe} from 'fp-ts/pipeable';
import {API} from 'aws-amplify';

import * as mutations from '../../graphql/mutations';

//++++++++
// TYPES +
//++++++++

//+++++++++++++++++
// REDUCER HELPERS+
//+++++++++++++++++

const submitFormHelper = async ({input, html, files}) => {
  const mutation = mutations.createProjectForm;
  const variables = {
    input
  };
  try {
    // throw {msg: 'There was an error! Please try again or call us at (859) 255-0077.', e: 'Error'};
    const sendEmail = await fetch('https://55cqd9yks8.execute-api.us-east-2.amazonaws.com/default/projectFormEmailNotification-staging', {
      method: 'post',
      mode: 'no-cors',
    //   headers: {
    //      'Access-Control-Request-Origin':'*',
    //      'Access-Control-Request-Headers':'POST',
    //   },
    body: JSON.stringify({
        customForm: {
          to: process.env.NODE_ENV === 'development' ? 'johnwcothran@gmail.com,soccadelic@gmail.com' : 'johnwcothran@gmail.com,larry@asphaltanimals.com,receptionist@asphaltanimals.com',
          from: 'candrasphalt@asphaltanimals.com',
          subject: 'C&R Asphalt Contact Form',
          files,
          html,
        }
      })
    });
    // // return 'success!';
    // return await API.graphql({
    //   query: mutation,
    //   variables,
    //   authMode: 'AWS_IAM'
    // });
  } catch (e) {
    console.error(e);
    throw {msg: 'There was an error! Please try again or call us at (859) 255-0077.', e};
  }

};

//+++++++++
// ACTIONS+
//+++++++++

const UPDATE = 'actions/contact/UPDATE';
const SUBMIT_FORM = 'actions/contact/SUBMIT_FORM';
const SUBMIT_FORM_SUCCESS = 'actions/contact/SUBMIT_FORM_SUCCESS';
const SUBMIT_FORM_FAIL = 'actions/contact/SUBMIT_FORM_FAIL';

//++++++++++
// REDUCERS+
//++++++++++

export const questions = {

  firstName: {
    questionText: 'What is your first name?',
    answer: null,
    required: true,
    type: 'firstName',
    label: 'First Name',
    inputPropType: 'text'
  },
  lastName: {
    questionText: 'What is your last name?',
    answer: null,
    required: true,
    type: 'lastName',
    label: 'Last Name',
    inputPropType: 'text'
  },
  organizationName: {
    questionText: "What is your company or organization's name?",
    answer: null,
    required: true,
    type: 'organizationName',
    label: 'Organization Name',
    inputPropType: 'text'
  },
  email: {
    questionText: "What is your email?",
    answer: null,
    required: true,
    type: 'email',
    label: 'Email',
    inputPropType: 'email'
  },
  phone: {
    questionText: "What is your phone?",
    answer: null,
    required: true,
    type: 'phone',
    label: 'Phone',
    inputPropType: 'tel'
  },
  customerMessage: {
    questionText: "Type a question",
    answer: null,
    required: true,
    type: 'customerMessage',
    label: 'Message to C & R',
    inputPropType: 'text',
    multiline: true
  },
}

export const initialState = {
    form: {
        currentQuestion: null,
        questions,
        review: false,
        submittingForm: false,
        submitFormError: null,
        open: false,
        submitSuccess: false
    }
};

export default function projectStart (state = initialState, action) {
    switch (action.type) {
        case UPDATE: {
            const { keypath, value } = action;
            return assocPath(keypath, value, state);
        }
        case SUBMIT_FORM: {
          const newState = pipe(state,
            st => assocPath(['form', 'submittingForm'], true, st),
          );
          const input = {
              email: state.form.questions.email.answer?.value,
              phone: state.form.questions.phone.answer?.value,
              firstName: state.form.questions.firstName.answer?.value,
              lastName: state.form.questions.lastName.answer?.value,
              organizationName: state.form.questions.organizationName.answer?.value,
              customerMessage: state.form.questions.customerMessage.answer?.value,
          };
          const html = state.form.report;
          const files = [];
          return loop(
            newState,
            Cmd.run(submitFormHelper, {
              args: [{input, html, files}],
              successActionCreator: onSubmitFormSuccess,
              failActionCreator: onSubmitFormFail
            })
          )
        }
        case SUBMIT_FORM_SUCCESS: {
          const newState = pipe(state,
            st => assocPath(['form', 'submittingForm'], false, st),
            st => assocPath(['form'], initialState.form, st),
            st => assocPath(['form', 'submitSuccess'], true, st),
          );
          return newState;
        }
        case SUBMIT_FORM_FAIL: {
          const { result } = action;
          const newState = pipe(state,
            st => assocPath(['form', 'submittingForm'], false, st),
            st => assocPath(['form', 'submitFormError'], result, st),
          );
          return newState;
        }
        default:
            return state;
    }
}

//++++++++++++++++++
// ACTIONS CREATORS+
//++++++++++++++++++


export function update(keypath, value) {
    return {
        type: UPDATE,
        keypath,
        value
    };
}

export function submitForm () {
  return {
    type: SUBMIT_FORM
  }
}

function onSubmitFormSuccess () {
  return {
    type: SUBMIT_FORM_SUCCESS
  }
}
function onSubmitFormFail (result) {
  return {
    type: SUBMIT_FORM_FAIL,
    result
  }
}
